export const generateImagesToolMessage = (toolMessage: any, results: any) => {
    const content = [{
        type: 'text',
        text: `Here are the results from the image generation:\n\`\`\`\n${results.results}\n\`\`\`\nFormat them in your response like this:\n![<image_description>](<image_url>)`
    }];

    return {...toolMessage, content: content}
}
